// extracted by mini-css-extract-plugin
export default {"container":"GeofenceTooltip_container__GzQ0c","text":"GeofenceTooltip_text__SSpov"};